module.exports = __webpack_public_path__ + "static/media/data-analyst-feature-tile-icon-02.df768af7.svg";